import _extends from 'babel-runtime/helpers/extends';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import SearchBar from '@/components/SearchV3/index.vue';
import Pagination from '@/components/Pagination/index.vue';
import TableList from '@/components/TableList/index.vue';
import AutoTips from '@/components/AutoTips/index.vue';
import searchMixin from '@/mixin/search';
import { getCreativePlanLogList } from '@/api/creative/report';
import { getAppTagTree, getProjectTagTree } from '@/api/common/apptag';
import { downloadWithNewWindow } from '@/common/download.js';
import { cookRequestParams } from '@/common/request.js';
import { v2Host } from '@/config/host';
import qs from 'qs';
import _ from 'lodash';
import { parseTime } from '@/filters/index';

export default {
  components: {
    SearchBar: SearchBar,
    Pagination: Pagination,
    TableList: TableList,
    AutoTips: AutoTips
  },
  mixins: [searchMixin],
  data: function data() {
    return {
      query: {
        page: 1,
        page_size: 15,
        adv_name: '',
        end_long_term: '',
        creative_types: [],
        app_tags: [],
        project_tags: [],
        startTime: [],
        endTime: []
      },
      pagination: {
        total: 0
      },
      listLoading: true,
      list: [],
      creativeTypeList: [{
        value: 1,
        label: 'graphic'
      }, {
        value: 2,
        label: 'video'
      }, {
        value: 3,
        label: 'playable'
      }],
      appTagList: [],
      projectTagList: []
    };
  },

  computed: {
    tableColumnConfig: function tableColumnConfig() {
      return [{
        label: 'ID',
        prop: 'id'
      }, {
        slot: 'adv_names'
      }, {
        label: '素材类型',
        prop: 'creative_types',
        params: {
          innerText: function innerText(_ref) {
            var row = _ref.row;

            return row.creative_types || '全部';
          }
        }
      }, {
        slot: 'app_tag_name'
      }, {
        slot: 'project_tag_name'
      }, {
        label: '推送开始时间',
        prop: 'start_time',
        params: {
          innerText: function innerText(_ref2) {
            var row = _ref2.row;

            return parseTime(row.start_time, '{y}-{m}-{d}') || '-';
          }
        }
      }, {
        label: '推送结束时间',
        prop: 'end_time',
        params: {
          innerText: function innerText(_ref3) {
            var row = _ref3.row;

            return row.end_time ? parseTime(row.end_time, '{y}-{m}-{d}') : '长期';
          }
        }
      }, {
        label: '计划创建时间',
        prop: 'created_time',
        params: {
          innerText: function innerText(_ref4) {
            var row = _ref4.row;

            return parseTime(row.created_time, '{y}-{m}-{d} {h}:{i}') || '-';
          }
        }
      }, {
        label: '计划创建人',
        prop: 'admin_name'
      }];
    },
    formItemList: function formItemList() {
      var list = {
        adv_name: {
          prop: 'adv_name',
          type: 'business',
          subtype: 'advertiser-selector',
          params: {
            filterable: true,
            valueKey: 'name',
            clearable: true
          }
        },
        creative_types: {
          type: 'select',
          prop: 'creative_types',
          params: {
            clearable: true,
            multiple: true,
            filterable: true,
            'collapse-tags': true,
            placeholder: '请选择素材类型',
            options: this.creativeTypeList
          }
        },

        app_tags: {
          type: 'cascader',
          prop: 'app_tags',
          params: {
            clearable: true,
            props: {
              children: 'child',
              emitPath: false,
              multiple: true,
              label: 'name',
              value: 'code'
            },
            placeholder: '请选择产品分类',
            'collapse-tags': true,
            'show-all-levels': false,
            options: this.appTagList
          }
        },
        project_tags: {
          type: 'cascader',
          prop: 'project_tags',
          params: {
            clearable: true,
            props: {
              children: 'child',
              emitPath: false,
              multiple: true,
              label: 'name',
              value: 'code'
            },
            placeholder: '请选择运营分类',
            'collapse-tags': true,
            'show-all-levels': false,
            options: this.projectTagList
          }
        },
        startTime: {
          label: '推送开始时间:',
          type: 'date-picker',
          subtype: 'daterange',
          prop: 'startTime',
          class: 'date-picker',
          params: {
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            pickerOptions: {}
          }
        },
        endTime: {
          label: '推送结束时间:',
          type: 'date-picker',
          subtype: 'daterange',
          prop: 'endTime',
          class: 'date-picker',
          params: {
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            disabled: this.query.end_long_term === true,
            pickerOptions: {}
          }
        },
        end_long_term: {
          type: 'checkbox-group',
          prop: 'end_long_term',
          params: function params(_ref5) {
            var formValue = _ref5.formValue;

            return {
              options: [{
                value: 1,
                label: '长期'
              }]
            };
          }
        }
      };
      return list;
    }
  },

  watch: {
    $route: function $route() {
      this.renderList();
    }
  },

  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this.query.end_long_term) {
                _this.query.end_long_term = _this.query.end_long_term !== 'false';
              }

              _this.getAppTagList();
              _this.getProjectTagList();
              _context.next = 5;
              return _this.renderList();

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },


  methods: {
    cookSearchParams: function cookSearchParams() {
      var _this2 = this;

      var params = _extends({}, this.query, {
        creative_types: this.creativeTypeList.filter(function (item) {
          return _this2.query.creative_types.includes(item.value);
        }).map(function (t) {
          return t.label;
        }).join(),
        start_time_begin: this.query.startTime ? this.query.startTime[0] : '',
        start_time_end: this.query.startTime ? this.query.startTime[1] : ''
      });

      if (this.query.end_long_term) {
        params.end_long_term = 1;
      } else {
        params.end_long_term = '';
        params.end_time_begin = this.query.endTime ? this.query.endTime[0] : '';
        params.end_time_end = this.query.endTime ? this.query.endTime[1] : '';
      }

      delete params.startTime;
      delete params.endTime;
      return params;
    },
    renderList: function renderList() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var params, res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.listLoading = true;
                _context2.prev = 1;
                params = _this3.cookSearchParams();
                _context2.next = 5;
                return getCreativePlanLogList(params);

              case 5:
                res = _context2.sent;


                _this3.list = _.get(res, 'data.data.list') || [];
                _this3.pagination.total = _.get(res, 'data.data.total');
                _this3.listLoading = false;
                _context2.next = 14;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2['catch'](1);

                _this3.listLoading = false;

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[1, 11]]);
      }))();
    },
    getAppTagList: function getAppTagList() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var res;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return getAppTagTree();

              case 3:
                res = _context3.sent;


                _this4.appTagList = (_.get(res, 'data.data') || []).map(function (item) {
                  return _extends({}, item, {
                    label: item.name,
                    value: item.code
                  });
                }) || [];
                _context3.next = 10;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3['catch'](0);

                console.log(_context3.t0);

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[0, 7]]);
      }))();
    },
    getProjectTagList: function getProjectTagList() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var res;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return getProjectTagTree();

              case 3:
                res = _context4.sent;


                _this5.projectTagList = (_.get(res, 'data.data') || []).map(function (item) {
                  return _extends({}, item, {
                    label: item.name,
                    value: item.code
                  });
                }) || [];
                _context4.next = 10;
                break;

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4['catch'](0);

                console.log(_context4.t0);

              case 10:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5, [[0, 7]]);
      }))();
    },
    downloadSheet: function downloadSheet() {
      var params = this.cookSearchParams();

      downloadWithNewWindow(v2Host + '/creative/plan/export-log-list?' + qs.stringify(_extends({}, cookRequestParams(params))));
    }
  }
};